import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
const programs = [{
  title: "Lil' Warriors",
  age: 'Ages 4-5',
  description: 'Building essential foundation skills through fun, engaging activities. Perfect for developing focus, balance, coordination, and discipline in our youngest martial artists.',
  image: 'https://cdn.magicpatterns.com/uploads/dNRDMUjXdKNw3ztfmZFiYU/image.png'
}, {
  title: 'Youth & Adult Classes',
  age: 'Ages 6+',
  description: 'Our most popular family program! Train together on the same mat—parents and kids learning blocks, kicks, self-defense, and fitness side by side. Perfect for building family bonds.',
  image: 'https://cdn.magicpatterns.com/uploads/eVfgbvi8r9gahN4jWY3v2C/Youth_and_Adult.png'
}, {
  title: 'Competition Team',
  age: 'Ages 6+',
  description: 'For dedicated athletes ready to take their taekwondo to the next level. Compete in tournaments, attend exclusive seminars, and join our elite sparring team family.',
  image: 'https://cdn.magicpatterns.com/uploads/9hN2ruYtXeWcnYkER2EJps/Competition_Team.png'
}];
export function ProgramsOverview() {
  return <section className="py-20 bg-gray-50" data-id="element-63">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-64">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-65">
          <div className="max-w-2xl" data-id="element-66">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-67">
              Programs for Every Age & Goal
            </h2>
            <p className="text-lg text-gray-600" data-id="element-68">
              From building confidence in our youngest students to competitive
              training for dedicated athletes—find the perfect program for your
              family in Brighton.
            </p>
          </div>
          <Link to="/programs" className="hidden md:block" data-id="element-69">
            <Button variant="outline" data-id="element-70">View All Programs</Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-71">
          {programs.map((program, index) => <motion.div key={program.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-72">
              <Card className="h-full flex flex-col hover:shadow-lg transition-shadow duration-300" data-id="element-73">
                <div className="h-48 overflow-hidden" data-id="element-74">
                  <img src={program.image} alt={program.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-75" />
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-76">
                  <div className="mb-4" data-id="element-77">
                    <span className="text-xs font-bold text-primary uppercase tracking-wider bg-blue-50 px-2 py-1 rounded" data-id="element-78">
                      {program.age}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-79">
                    {program.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-6 flex-1" data-id="element-80">
                    {program.description}
                  </p>
                  <Link to="/programs" className="mt-auto" data-id="element-81">
                    <Button variant="secondary" size="sm" fullWidth data-id="element-82">
                      Learn More
                    </Button>
                  </Link>
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-83">
          <Link to="/programs" data-id="element-84">
            <Button variant="outline" fullWidth data-id="element-85">
              View All Programs
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}